import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UtilService } from '../../../shared/services/util/util.service';

@Component({
  selector: 'app-update-summary',
  templateUrl: './update-summary.component.html',
  styleUrls: ['./update-summary.component.scss']
})
export class UpdateSummaryComponent implements OnInit {

  @Input() summaryDetails;
  @Input() currencyIcon;
  @Input() currency;

  constructor(
    public utilService: UtilService
  ) { }

  ngOnInit() {
  }


}
